// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"87ffb79c","453":"d318abaf","455":"a4001a3d","977":"bce8b4d5"}[chunkId] + ".chunk.js";
};